module.exports = __webpack_public_path__ + "static/ip-ikon8-a9ba6c5db6f91d2c615712b5218cde57.png";